import {
  PreVisitSummaryCardConnected,
  ProviderEventType,
  useSetCoachConversation,
} from '@grow-therapy-team/seedling-components';

import { usePreVisitSummaryCardWrapper } from './usePreVisitSummaryCardWrapper';

export function PreVisitSummaryCardWrapper() {
  const {
    appointmentShortId,
    patientShortId,
    nudgeContext,
    preVisitSummaryCardComponent,
    resourceButtonOnClickHandlers,
  } = usePreVisitSummaryCardWrapper();

  const { setCoachConversation } = useSetCoachConversation();

  if (!appointmentShortId || !patientShortId) {
    return null;
  }

  return (
    <PreVisitSummaryCardConnected
      appointmentShortId={appointmentShortId}
      patientShortId={patientShortId}
      providerViewEventType={ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_TELEHEALTH}
      includeTitle
      nudgeContext={nudgeContext}
      preVisitSummaryCardComponent={preVisitSummaryCardComponent}
      onClickUnreadCoachConversation={setCoachConversation}
      resourceButtonOnClickHandlers={resourceButtonOnClickHandlers}
    />
  );
}
